import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetSoldPackagingItemRecords } from '@shared/api/hooks/sold-goods/packaging';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import SoldPackagingItemSalesTable from '../components/item/sold-packaging-item-sales-table';
import { useSoldPackagingItem } from '../sold-packaging-item-context';

export default function SoldPackagingItemSalesPage() {
  const { item } = useSoldPackagingItem();

  const [companyReports] = useQueryState(
    'companyReport',
    parseAsArrayOf(parseAsString)
  );

  const { page, perPage, period, site, sort } = useDataTableQueryState({
    filters: ['period', 'site'],
  });

  const {
    data,
    status,
    isLoading,
    isFetching,
    isPreviousData,
    isFetchedAfterMount,
  } = useGetSoldPackagingItemRecords({
    activityUuid: item.uuid,
    params: {
      page_size: perPage,
      company_reports: companyReports || undefined,
      page,
      sites: site || undefined,
      time_periods: period || undefined,
      sort: formatMultipleSortingForEndpoint(sort! || []),
    },
  });
  return (
    <Page name={`${item.packagingName} sales`} page="subpage">
      <SoldPackagingItemSalesTable
        data={data!}
        status={status}
        isLoading={isLoading}
        isFetching={isFetching}
        isPreviousData={isPreviousData}
        isFetchedAfterMount={isFetchedAfterMount}
      />
    </Page>
  );
}
